<template>
  <d-modal
    v-if="showModal"
    class="showModalVisitsInfo"
    style="background-color: rgba(0,0,0,0.8)!important;">
    <button
      @click.prevent.stop="closeModal"
      class="mr-1 new-close-button">
      <i class="material-icons close-icon">close</i>
    </button>
    <d-modal-header class="showModalVisits__header">
      <d-modal-title class="showModalVisits__header_title">
        <span><i class="material-icons">groups</i> Lista rezerwowych</span> - Dodaj do listy
      </d-modal-title>
    </d-modal-header>
    <d-modal-body class="showModalVisits__body">
      <d-form>
        <d-card class="mb-5">
          <d-tabs card class="showModalVisits">
            <d-tab>
              <validation-observer ref="reservation-list-form-add" tag="form">
                <div class="form-group">
                  <div class="mb-4"><h3>Powód zgłoszenia</h3><div class="border"></div></div>
                  <div v-for="(reservation, indexReservation) in reservationForm" :key="'reservation-guardian-' + indexReservation">
                    <div class="form-group reservation-box" style="margin-bottom: 1.8rem;" v-if="(reservation.type === 'select') && (reservation.multiselect === 1) && reservation.section === 'other'">
                      <validation-provider
                        :rules="reservation.required === 1 ? 'required' : ''"
                        :name="reservation.name"
                        v-slot="{ errors }">
                        <div class="form-group">
                          <label class="title-box" :for="reservation.name">
                            {{reservation.label}}
                            <span v-if="reservation.required === 1" style="color: #c4183c">*</span>
                          </label>
                          <multi-select
                            :ref="reservation.ref ? reservation.ref : ''"
                            :class="['reservation-style', 'reservation-style-select-mid', errors[0] ? 'reservation-style-select-mid-invalid': '']"
                            :multiple="true"
                            placeholder="Wybierz..."
                            :options="reservation.possibleValues"
                            v-model="reservation.value"
                            :track-by="'id'"
                            label="name"
                            select-label="Wybierz"
                            deselectLabel="Usuń wybór"
                            selectedLabel="Wybrane"
                          />
                        </div>
                        <p class="reservation-note" v-if="reservation.text">{{reservation.text}}</p>
                        <div class="invalid-feedback" style="display: block; margin-top: -0.8rem;">
                          {{ errors[0] }}
                        </div>
                      </validation-provider>
                    </div>
                    <div class="form-group" v-if="reservation.conditionalReasonField
                    && reservation.name === reservation.conditionalReasonField.triggerName
                    && reservation.value
                    && reservation.value.some(val => val.id === reservation.conditionalReasonField.triggerValueId)"
                         style="display: flex; align-items: center;">
                      <d-checkbox
                        v-model="reservation.conditionalFieldConfirm"
                        :class="'mb-3'"
                        toggle>
                        <span class="title-box">{{reservation.conditionalReasonField.label}}</span>
                      </d-checkbox>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="mb-4" ><h3>Wnioskodawca</h3><div class="border"></div></div>
                  <div v-for="(reservation, indexReservation) in reservationForm" :key="'reservation-guardian-' + indexReservation">
                    <div class="form-group" v-if="reservation.type === 'input' && reservation.section === 'guardian'">
                      <label class="title-box" :for="reservation.name">
                        {{reservation.label}} <span v-if="reservation.required === 1" style="color: #c4183c">*</span>
                      </label>
                      <validation-provider
                        :name="'valid-' +  indexReservation"
                        :rules="reservation.required === 1 ? ( reservation.max_length ? `required|min:${reservation.max_length}` : 'required') : ''"
                        v-slot="{ errors }">
                        <d-input
                          :name="'text-' +  indexReservation"
                          class="reservation-style"
                          :state="errors.length ? 'invalid' : null"
                          v-model="reservation.value"
                        />
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </validation-provider>
                      <p class="reservation-note" v-if="reservation.text">{{reservation.text}}</p>
                    </div>
                    <div class="form-group reservation-box" v-if="reservation.type === 'phone' && reservation.section === 'guardian'">
                      <label class="title-box" :for="reservation.name">
                        {{reservation.label}} <span v-if="reservation.required === 1">*</span>
                      </label>
                      <validation-provider
                        :rules="reservation.required === 1 ? 'required|min:9' : 'min:9'"
                        :name="reservation.name"
                        v-slot="{ errors }">
                        <d-input
                          :name="'text-' +  indexReservation"
                          class="reservation-style"
                          v-model="reservation.value"
                          type="number"
                          @input="reservation.value = reservation.value.toString().slice(0, 9)"
                          :state="errors.length ? 'invalid' : null"
                        />
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </validation-provider>
                      <p class="reservation-note" v-if="reservation.text">{{reservation.text}}</p>
                    </div>
                    <div class="form-group reservation-box" v-if="reservation.type === 'email' && reservation.section === 'guardian'">
                      <label class="title-box" :for="reservation.name">
                        {{reservation.label}} <span v-if="reservation.required === 1">*</span>
                      </label>
                      <validation-provider
                        :rules="reservation.required === 1 ? 'required|email' : 'email'"
                        :name="reservation.name"
                        v-slot="{ errors }">
                        <d-input
                          :name="'text-' +  indexReservation"
                          class="reservation-style"
                          v-model="reservation.value"
                          type="email"
                          :state="errors.length ? 'invalid' : null"
                        />
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </validation-provider>
                      <p class="reservation-note" v-if="reservation.text">{{reservation.text}}</p>
                    </div>
                    <div class="form-group" v-if="(reservation.type === 'input_workshop' && reservation.section === 'guardian') && inputWork">
                      <label class="title-box" :for="reservation.name">
                        {{reservation.label}} <span v-if="reservation.required === 1" style="color: #c4183c">*</span>
                      </label>
                      <validation-provider
                        :name="'valid-' +  indexReservation"
                        :rules="reservation.required === 1 ? ( reservation.max_length ? `required|min:${reservation.max_length}` : 'required') : ''"
                        v-slot="{ errors }">
                        <d-input
                          :name="'text-' +  indexReservation"
                          class="reservation-style"
                          :state="errors.length ? 'invalid' : null"
                          v-model="reservation.value"
                        />
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </validation-provider>
                      <p class="reservation-note" v-if="reservation.text">{{reservation.text}}</p>
                    </div>
                    <div class="form-group" v-if="reservation.type === 'date' && reservation.section === 'guardian'">
                      <label class="title-box" :for="reservation.name">
                        {{reservation.label}} <span v-if="reservation.required === 1" style="color: #c4183c">*</span>
                      </label>
                      <validation-provider
                        :rules="reservation.required === 1 ? 'required' : ''"
                        :name="reservation.name"
                        v-slot="{ errors }">
                        <date-picker
                          class="reservation-style mr-2"
                          v-model="reservation.value"
                          valueType="format"
                          style="width: 100%"
                        />
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </validation-provider>
                      <p class="reservation-note" v-if="reservation.text">{{reservation.text}}</p>
                    </div>
                    <div class="form-group" v-if="reservation.type === 'textarea' && reservation.section === 'guardian'">
                      <label class="title-box" :for="reservation.name">
                        {{reservation.label}} <span v-if="reservation.required === 1" style="color: #c4183c">*</span>
                      </label>
                      <validation-provider
                        :rules="reservation.required === 1 ? 'required' : ''"
                        :name="reservation.name"
                        v-slot="{ errors }">
                    <textarea
                      class="reservation-style"
                      :state="errors.length ? 'invalid' : null"
                      v-model="reservation.value"
                    ></textarea>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </validation-provider>
                      <p class="reservation-note" v-if="reservation.text">{{reservation.text}}</p>
                    </div>
                    <div class="form-group" style="margin-bottom: 1.2rem;" v-if="(reservation.type === 'select' && reservation.section === 'guardian') && (reservation.multiselect === 0)">
                      <validation-provider
                        :rules="reservation.required === 1 ? 'required' : ''"
                        :name="reservation.name"
                        v-slot="{ errors }">
                        <div class="form-group">
                          <label class="title-box" :for="reservation.name">
                            {{reservation.label}}
                            <span v-if="reservation.required === 1" style="color: #c4183c">*</span>
                          </label>
                          <v-select
                            :ref="reservation.ref ? reservation.ref : ''"
                            class="reservation-style reservation-style-select-mid"
                            :options="reservation.possibleValues"
                            v-model="reservation.value"
                            :reduce="boss => boss.id"
                            label="id">
                            <template #search="{attributes, events}">
                              <d-input
                                class="input-for-select"
                                :state="errors.length ? 'invalid' : null"
                                :required="!reservation.value"
                                v-bind="attributes"
                                v-on="events"
                              />
                            </template>
                            <template slot="option" slot-scope="option">
                              <div class="d-center">
                                {{ option.name }}
                              </div>
                            </template>
                            <template slot="selected-option" slot-scope="option">
                              <div class="selected d-center">
                                {{ option.name }}
                              </div>
                            </template>
                          </v-select>
                        </div>
                        <p class="reservation-note" v-if="reservation.text">{{reservation.text}}</p>
                        <div class="invalid-feedback" style="display: block; margin-top: -0.8rem;">
                          {{ errors[0] }}
                        </div>
                      </validation-provider>
                    </div>
                    <div class="form-group" style="margin-bottom: 1.2rem;" v-if="(reservation.type === 'select' && reservation.section === 'guardian') && (reservation.multiselect === 1)">
                      <validation-provider
                        :rules="reservation.required === 1 ? 'required' : ''"
                        :name="reservation.name"
                        v-slot="{ errors }">
                        <div class="form-group">
                          <label class="title-box" :for="reservation.name">
                            {{reservation.label}}
                            <span v-if="reservation.required === 1" style="color: #c4183c">*</span>
                          </label>
                          <multi-select
                            :ref="reservation.ref ? reservation.ref : ''"
                            :class="['reservation-style', 'reservation-style-select-mid', errors[0] ? 'reservation-style-select-mid-invalid': '']"
                            :multiple="true"
                            placeholder="Wybierz..."
                            :options="reservation.possibleValues"
                            v-model="reservation.value"
                            :track-by="'id'"
                            label="name"
                            select-label="Wybierz"
                            deselectLabel="Usuń wybór"
                            selectedLabel="Wybrane"
                          />
                        </div>
                        <p class="reservation-note" v-if="reservation.text">{{reservation.text}}</p>
                        <div class="invalid-feedback" style="display: block; margin-top: -0.8rem;">
                          {{ errors[0] }}
                        </div>
                      </validation-provider>
                    </div>
                    <div class="form-group" v-if="reservation.type === 'checkbox' && reservation.section === 'guardian'">
                      <d-checkbox
                        class="reservation-style"
                        :value="'1'"
                        :unchecked-value="'0'"
                        v-model="reservation.value"
                        :class="'mb-3'"
                        toggle>
                        <span class="title-box">{{reservation.label}}</span>
                      </d-checkbox>
                      <p class="reservation-note" v-if="reservation.text">{{reservation.text}}</p>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="mb-4" ><h3>Dane dziecka</h3><div class="border"></div></div>
                  <div v-for="(reservation, indexReservation) in reservationForm" :key="'reservation-patient-' + indexReservation">
                    <div class="form-group" v-if="reservation.type === 'input' && reservation.section === 'patient'">
                      <label class="title-box" :for="reservation.name">
                        {{reservation.label}} <span v-if="reservation.required === 1" style="color: #c4183c">*</span>
                      </label>
                      <validation-provider
                        :name="'valid-' +  indexReservation"
                        :rules="reservation.required === 1 ? ( reservation.max_length ? `required|min:${reservation.max_length}` : 'required') : ''"
                        v-slot="{ errors }">
                        <d-input
                          :name="'text-' +  indexReservation"
                          class="reservation-style"
                          :state="errors.length ? 'invalid' : null"
                          v-model="reservation.value"
                        />
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </validation-provider>
                      <p class="reservation-note" v-if="reservation.text">{{reservation.text}}</p>
                    </div>
                    <div class="form-group" v-if="(reservation.type === 'input_workshop') && inputWork && reservation.section === 'patient'">
                      <label class="title-box" :for="reservation.name">
                        {{reservation.label}} <span v-if="reservation.required === 1" style="color: #c4183c">*</span>
                      </label>
                      <validation-provider
                        :name="'valid-' +  indexReservation"
                        :rules="reservation.required === 1 ? ( reservation.max_length ? `required|min:${reservation.max_length}` : 'required') : ''"
                        v-slot="{ errors }">
                        <d-input
                          :name="'text-' +  indexReservation"
                          class="reservation-style"
                          :state="errors.length ? 'invalid' : null"
                          v-model="reservation.value"
                        />
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </validation-provider>
                      <p class="reservation-note" v-if="reservation.text">{{reservation.text}}</p>
                    </div>
                    <div class="form-group" v-if="reservation.type === 'date' && reservation.section === 'patient'">
                      <label class="title-box" :for="reservation.name">
                        {{reservation.label}} <span v-if="reservation.required === 1" style="color: #c4183c">*</span>
                      </label>
                      <validation-provider
                        :rules="reservation.required === 1 ? 'required' : ''"
                        :name="reservation.name"
                        v-slot="{ errors }">
                        <date-picker
                          :class="['reservation-style', 'mr-2', (importantDate === true && !reservation.value) ? 'invalid-date' : '']"
                          v-model="reservation.value"
                          validate
                          valueType="format"
                          style="width: 100%"/>
                      </validation-provider>
                      <div class="invalid-feedback" style="display: block;" v-if="importantDate === true && !reservation.value">
                        To pole jest wymagane
                      </div>
                      <p class="reservation-note" v-if="reservation.text">{{reservation.text}}</p>
                    </div>
                    <div class="form-group" v-if="reservation.type === 'textarea' && reservation.section === 'patient'">
                      <label class="title-box" :for="reservation.name">
                        {{reservation.label}} <span v-if="reservation.required === 1" style="color: #c4183c">*</span>
                      </label>
                      <validation-provider
                        :rules="reservation.required === 1 ? 'required' : ''"
                        :name="reservation.name"
                        v-slot="{ errors }">
                      <textarea
                        class="reservation-style"
                        :state="errors.length ? 'invalid' : null"
                        v-model="reservation.value"
                      ></textarea>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </validation-provider>
                      <p class="reservation-note" v-if="reservation.text">{{reservation.text}}</p>
                    </div>
                    <div class="form-group" style="margin-bottom: 1.2rem;" v-if="(reservation.type === 'select') && (reservation.multiselect === 0) && reservation.section === 'patient'">
                      <validation-provider
                        :rules="reservation.required === 1 ? 'required' : ''"
                        :name="reservation.name"
                        v-slot="{ errors }">
                        <div class="form-group">
                          <label class="title-box" :for="reservation.name">
                            {{reservation.label}}
                            <span v-if="reservation.required === 1" style="color: #c4183c">*</span>
                          </label>
                          <v-select
                            :ref="reservation.ref ? reservation.ref : ''"
                            class="reservation-style reservation-style-select-mid"
                            :options="reservation.possibleValues"
                            v-model="reservation.value"
                            :reduce="boss => boss.id"
                            label="id">
                            <template #search="{attributes, events}">
                              <d-input
                                class="input-for-select"
                                :state="errors.length ? 'invalid' : null"
                                :required="!reservation.value"
                                v-bind="attributes"
                                v-on="events"
                              />
                            </template>
                            <template slot="option" slot-scope="option">
                              <div class="d-center">
                                {{ option.name }}
                              </div>
                            </template>
                            <template slot="selected-option" slot-scope="option">
                              <div class="selected d-center">
                                {{ option.name }}
                              </div>
                            </template>
                          </v-select>
                        </div>
                        <p class="reservation-note" v-if="reservation.text">{{reservation.text}}</p>
                        <div class="invalid-feedback" style="display: block; margin-top: -0.8rem;">
                          {{ errors[0] }}
                        </div>
                      </validation-provider>
                    </div>
                    <div class="form-group" style="margin-bottom: 1.2rem;" v-if="(reservation.type === 'select') && (reservation.multiselect === 1) && reservation.section === 'patient'">
                      <validation-provider
                        :rules="reservation.required === 1 ? 'required' : ''"
                        :name="reservation.name"
                        v-slot="{ errors }">
                        <div class="form-group">
                          <label class="title-box" :for="reservation.name">
                            {{reservation.label}}
                            <span v-if="reservation.required === 1" style="color: #c4183c">*</span>
                          </label>
                          <multi-select
                            :ref="reservation.ref ? reservation.ref : ''"
                            :class="['reservation-style', 'reservation-style-select-mid', errors[0] ? 'reservation-style-select-mid-invalid': '']"
                            :multiple="true"
                            placeholder="Wybierz..."
                            :options="reservation.possibleValues"
                            v-model="reservation.value"
                            :track-by="'id'"
                            label="name"
                            select-label="Wybierz"
                            deselectLabel="Usuń wybór"
                            selectedLabel="Wybrane"
                          />
                        </div>
                        <p class="reservation-note" v-if="reservation.text">{{reservation.text}}</p>
                        <div class="invalid-feedback" style="display: block; margin-top: -0.8rem;">
                          {{ errors[0] }}
                        </div>
                      </validation-provider>
                    </div>
                    <div class="form-group" v-if="reservation.type === 'checkbox' && reservation.section === 'patient'">
                      <d-checkbox
                        class="reservation-style"
                        :value="'1'"
                        :unchecked-value="'0'"
                        v-model="reservation.value"
                        :class="'mb-3'"
                        toggle>
                        <span class="title-box">{{reservation.label}}</span>
                      </d-checkbox>
                      <p class="reservation-note" v-if="reservation.text">{{reservation.text}}</p>
                    </div>
                  </div>
                  <div v-if="visibleBox">
                    <div
                      v-for="(reservation, patientReservation) in patients"
                      :key="'reservation-' + patientReservation">
                      <div class="form-group" v-if="reservation.type === 'input' && reservation.section === 'patient'">
                        <label class="title-box" :for="reservation.name">
                          {{reservation.label}} <span v-if="reservation.required === 1" style="color: #c4183c">*</span>
                        </label>
                        <validation-provider
                          :rules="reservation.required === 1 ? 'required' : ''"
                          :name="reservation.name"
                          v-slot="{ errors }">
                          <d-input
                            class="reservation-style"
                            :state="errors.length ? 'invalid' : null"
                            v-model="reservation.value"
                          />
                          <div class="invalid-feedback">
                            {{ errors[0] }}
                          </div>
                        </validation-provider>
                        <p class="reservation-note" v-if="reservation.text">{{reservation.text}}</p>
                      </div>
                      <div class="form-group" v-if="reservation.type === 'date' && reservation.section === 'patient'">
                        <label class="title-box" :for="reservation.name">
                          {{reservation.label}} <span v-if="reservation.required === 1" style="color: #c4183c">*</span>
                        </label>
                        <validation-provider
                          :rules="reservation.required === 1 ? 'required' : ''"
                          :name="reservation.name"
                          v-slot="{ errors }">
                          <date-picker
                            :class="['reservation-style', 'mr-2', (importantDate === true && !reservation.value) ? 'invalid-date' : '']"
                            v-model="reservation.value"
                            validate
                            valueType="format"
                            style="width: 100%"/>
                        </validation-provider>
                        <div class="invalid-feedback" style="display: block;" v-if="importantDate === true && !reservation.value">
                          To pole jest wymagane
                        </div>
                        <p class="reservation-note" v-if="reservation.text">{{reservation.text}}</p>
                      </div>
                      <div class="form-group" v-if="reservation.type === 'textarea' && reservation.section === 'patient'">
                        <label class="title-box" :for="reservation.name">
                          {{reservation.label}} <span v-if="reservation.required === 1" style="color: #c4183c">*</span>
                        </label>
                        <validation-provider
                          :rules="reservation.required === 1 ? 'required' : ''"
                          :name="reservation.name"
                          v-slot="{ errors }">
                          <textarea
                            class="reservation-style"
                            :state="errors.length ? 'invalid' : null"
                            v-model="reservation.value"
                          ></textarea>
                          <div class="invalid-feedback">
                            {{ errors[0] }}
                          </div>
                        </validation-provider>
                        <p class="reservation-note" v-if="reservation.text">{{reservation.text}}</p>
                      </div>
                      <div class="form-group" style="margin-bottom: 1.2rem;" v-if="reservation.type === 'select' && reservation.section === 'patient'">
                        <validation-provider
                          :rules="reservation.required === 1 ? 'required' : ''"
                          :name="reservation.name"
                          v-slot="{ errors }">
                          <div class="form-group">
                            <label class="title-box" :for="reservation.name">
                              {{reservation.label}}
                              <span v-if="reservation.required === 1" style="color: #c4183c">*</span>
                            </label>
                            <v-select
                              :ref="reservation.ref ? reservation.ref : ''"
                              class="reservation-style reservation-style-select-mid"
                              :options="reservation.possibleValues"
                              v-model="reservation.value"
                              :reduce="boss => boss.id"
                              label="id">
                              <template #search="{attributes, events}">
                                <d-input
                                  class="input-for-select"
                                  :state="errors.length ? 'invalid' : null"
                                  :required="!reservation.value"
                                  v-bind="attributes"
                                  v-on="events"
                                />
                              </template>
                              <template slot="option" slot-scope="option">
                                <div class="d-center">
                                  {{ option.name }}
                                </div>
                              </template>
                              <template slot="selected-option" slot-scope="option">
                                <div class="selected d-center">
                                  {{ option.name }}
                                </div>
                              </template>
                            </v-select>
                          </div>
                          <p class="reservation-note" v-if="reservation.text">{{reservation.text}}</p>
                          <div class="invalid-feedback" style="display: block; margin-top: -0.8rem;">
                            {{ errors[0] }}
                          </div>
                        </validation-provider>
                      </div>
                      <div class="form-group" v-if="reservation.type === 'checkbox' && reservation.section === 'patient'">
                        <d-checkbox
                          class="reservation-style"
                          :value="'1'"
                          :unchecked-value="'0'"
                          v-model="reservation.value"
                          :class="'mb-3'"
                          toggle>
                          <span class="title-box">{{reservation.label}}</span>
                        </d-checkbox>
                        <p class="reservation-note" v-if="reservation.text">{{reservation.text}}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="mb-4" ><h3>Dane szkoły</h3><div class="border"></div></div>
                  <div v-for="(reservation, indexReservation) in reservationForm" :key="'reservation-school-' + indexReservation">
                    <div class="form-group" v-if="reservation.type === 'input' && reservation.section === 'school'">
                      <label class="title-box" :for="reservation.name">
                        {{reservation.label}} <span v-if="reservation.required === 1" style="color: #c4183c">*</span>
                      </label>
                      <validation-provider
                        :name="'valid-' +  indexReservation"
                        :rules="reservation.required === 1 ? ( reservation.max_length ? `required|min:${reservation.max_length}` : 'required') : ''"
                        v-slot="{ errors }">
                        <d-input
                          :name="'text-' +  indexReservation"
                          class="reservation-style"
                          :state="errors.length ? 'invalid' : null"
                          v-model="reservation.value"
                        />
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </validation-provider>
                      <p class="reservation-note" v-if="reservation.text">{{reservation.text}}</p>
                    </div>
                    <div class="form-group" v-if="(reservation.type === 'input_workshop') && inputWork && reservation.section === 'school'">
                      <label class="title-box" :for="reservation.name">
                        {{reservation.label}} <span v-if="reservation.required === 1" style="color: #c4183c">*</span>
                      </label>
                      <validation-provider
                        :name="'valid-' +  indexReservation"
                        :rules="reservation.required === 1 ? ( reservation.max_length ? `required|min:${reservation.max_length}` : 'required') : ''"
                        v-slot="{ errors }">
                        <d-input
                          :name="'text-' +  indexReservation"
                          class="reservation-style"
                          :state="errors.length ? 'invalid' : null"
                          v-model="reservation.value"
                        />
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </validation-provider>
                      <p class="reservation-note" v-if="reservation.text">{{reservation.text}}</p>
                    </div>
                    <div class="form-group" v-if="reservation.type === 'date' && reservation.section === 'school'">
                      <label class="title-box" :for="reservation.name">
                        {{reservation.label}} <span v-if="reservation.required === 1" style="color: #c4183c">*</span>
                      </label>
                      <validation-provider
                        :rules="reservation.required === 1 ? 'required' : ''"
                        :name="reservation.name"
                        v-slot="{ errors }">
                        <date-picker
                          :class="['reservation-style', 'mr-2', (importantDate === true && !reservation.value) ? 'invalid-date' : '']"
                          v-model="reservation.value"
                          validate
                          valueType="format"
                          style="width: 100%"/>
                      </validation-provider>
                      <div class="invalid-feedback" style="display: block;" v-if="importantDate === true && !reservation.value">
                        To pole jest wymagane
                      </div>
                      <p class="reservation-note" v-if="reservation.text">{{reservation.text}}</p>
                    </div>
                    <div class="form-group" v-if="reservation.type === 'textarea' && reservation.section === 'school'">
                      <label class="title-box" :for="reservation.name">
                        {{reservation.label}} <span v-if="reservation.required === 1" style="color: #c4183c">*</span>
                      </label>
                      <validation-provider
                        :rules="reservation.required === 1 ? 'required' : ''"
                        :name="reservation.name"
                        v-slot="{ errors }">
                      <textarea
                        class="reservation-style"
                        :state="errors.length ? 'invalid' : null"
                        v-model="reservation.value"
                      ></textarea>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </validation-provider>
                      <p class="reservation-note" v-if="reservation.text">{{reservation.text}}</p>
                    </div>
                    <div class="form-group" style="margin-bottom: 1.2rem;" v-if="(reservation.type === 'select') && (reservation.multiselect === 0) && reservation.section === 'school'">
                      <validation-provider
                        :rules="reservation.required === 1 ? 'required' : ''"
                        :name="reservation.name"
                        v-slot="{ errors }">
                        <div class="form-group">
                          <label class="title-box" :for="reservation.name">
                            {{reservation.label}}
                            <span v-if="reservation.required === 1" style="color: #c4183c">*</span>
                          </label>
                          <v-select
                            :ref="reservation.ref ? reservation.ref : ''"
                            class="reservation-style reservation-style-select-mid"
                            :options="reservation.possibleValues"
                            v-model="reservation.value"
                            :reduce="boss => boss.id"
                            label="id">
                            <template #search="{attributes, events}">
                              <d-input
                                class="input-for-select"
                                :state="errors.length ? 'invalid' : null"
                                :required="!reservation.value"
                                v-bind="attributes"
                                v-on="events"
                              />
                            </template>
                            <template slot="option" slot-scope="option">
                              <div class="d-center">
                                {{ option.name }}
                              </div>
                            </template>
                            <template slot="selected-option" slot-scope="option">
                              <div class="selected d-center">
                                {{ option.name }}
                              </div>
                            </template>
                          </v-select>
                        </div>
                        <p class="reservation-note" v-if="reservation.text">{{reservation.text}}</p>
                        <div class="invalid-feedback" style="display: block; margin-top: -0.8rem;">
                          {{ errors[0] }}
                        </div>
                      </validation-provider>
                    </div>
                    <div class="form-group" style="margin-bottom: 1.2rem;" v-if="(reservation.type === 'select') && (reservation.multiselect === 1) && reservation.section === 'school'">
                      <validation-provider
                        :rules="reservation.required === 1 ? 'required' : ''"
                        :name="reservation.name"
                        v-slot="{ errors }">
                        <div class="form-group">
                          <label class="title-box" :for="reservation.name">
                            {{reservation.label}}
                            <span v-if="reservation.required === 1" style="color: #c4183c">*</span>
                          </label>
                          <multi-select
                            :ref="reservation.ref ? reservation.ref : ''"
                            :class="['reservation-style', 'reservation-style-select-mid', errors[0] ? 'reservation-style-select-mid-invalid': '']"
                            :multiple="true"
                            placeholder="Wybierz..."
                            :options="reservation.possibleValues"
                            v-model="reservation.value"
                            :track-by="'id'"
                            label="name"
                            select-label="Wybierz"
                            deselectLabel="Usuń wybór"
                            selectedLabel="Wybrane"
                          />
                        </div>
                        <p class="reservation-note" v-if="reservation.text">{{reservation.text}}</p>
                        <div class="invalid-feedback" style="display: block; margin-top: -0.8rem;">
                          {{ errors[0] }}
                        </div>
                      </validation-provider>
                    </div>
                    <div class="form-group" v-if="reservation.type === 'checkbox' && reservation.section === 'school'">
                      <d-checkbox
                        class="reservation-style"
                        :value="'1'"
                        :unchecked-value="'0'"
                        v-model="reservation.value"
                        :class="'mb-3'"
                        toggle>
                        <span class="title-box">{{reservation.label}}</span>
                      </d-checkbox>
                      <p class="reservation-note" v-if="reservation.text">{{reservation.text}}</p>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="mb-4" ><h3>Dodatkowe informacje</h3><div class="border"></div></div>
                  <div v-for="(reservation, indexReservation) in reservationForm" :key="'reservation-other-' + indexReservation">
                    <div class="form-group reservation-box" v-if="reservation.type === 'input' && reservation.section === 'other'">
                      <label class="title-box" :for="reservation.name">
                        {{reservation.label}} <span v-if="reservation.required === 1" style="color: #c4183c">*</span>
                      </label>
                      <validation-provider
                        :name="'valid-' +  indexReservation"
                        :rules="reservation.required === 1 ? ( reservation.max_length ? `required|min:${reservation.max_length}` : 'required') : ''"
                        v-slot="{ errors }">
                        <d-input
                          :name="'text-' +  indexReservation"
                          class="reservation-style"
                          :state="errors.length ? 'invalid' : null"
                          v-model="reservation.value"
                        />
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </validation-provider>
                      <p class="reservation-note" v-if="reservation.text">{{reservation.text}}</p>
                    </div>
                    <div class="form-group reservation-box" v-if="reservation.type === 'input_therapy' && reservation.section === 'other' && therapy === true">
                      <label class="title-box" :for="reservation.name">
                        {{reservation.label}} <span v-if="reservation.required === 1" style="color: #c4183c">*</span>
                      </label>
                      <validation-provider
                        :name="'valid-' +  indexReservation"
                        :rules="reservation.required === 1 ? ( reservation.max_length ? `required|min:${reservation.max_length}` : 'required') : ''"
                        v-slot="{ errors }">
                        <d-input
                          :name="'text-' +  indexReservation"
                          class="reservation-style"
                          :state="errors.length ? 'invalid' : null"
                          v-model="reservation.value"
                        />
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </validation-provider>
                      <p class="reservation-note" v-if="reservation.text">{{reservation.text}}</p>
                    </div>
                    <div class="form-group reservation-box" v-if="(reservation.type === 'input_workshop') && inputWork && reservation.section === 'other'">
                      <label class="title-box" :for="reservation.name">
                        {{reservation.label}} <span v-if="reservation.required === 1" style="color: #c4183c">*</span>
                      </label>
                      <validation-provider
                        :name="'valid-' +  indexReservation"
                        :rules="reservation.required === 1 ? ( reservation.max_length ? `required|min:${reservation.max_length}` : 'required') : ''"
                        v-slot="{ errors }">
                        <d-input
                          :name="'text-' +  indexReservation"
                          class="reservation-style"
                          :state="errors.length ? 'invalid' : null"
                          v-model="reservation.value"
                        />
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </validation-provider>
                      <p class="reservation-note" v-if="reservation.text">{{reservation.text}}</p>
                    </div>
                    <div class="form-group reservation-box" v-if="reservation.type === 'date' && reservation.section === 'other'">
                      <label class="title-box" :for="reservation.name">
                        {{reservation.label}} <span v-if="reservation.required === 1" style="color: #c4183c">*</span>
                      </label>
                      <validation-provider
                        :rules="reservation.required === 1 ? 'required' : ''"
                        :name="reservation.name"
                        v-slot="{ errors }">
                        <date-picker
                          :class="['reservation-style', 'mr-2', (importantDate === true && !reservation.value) ? 'invalid-date' : '']"
                          v-model="reservation.value"
                          validate
                          valueType="format"
                          style="width: 100%"/>
                      </validation-provider>
                      <div class="invalid-feedback" style="display: block;" v-if="importantDate === true && !reservation.value">
                        To pole jest wymagane
                      </div>
                      <p class="reservation-note" v-if="reservation.text">{{reservation.text}}</p>
                    </div>
                    <div class="form-group reservation-box" v-if="reservation.type === 'textarea' && reservation.section === 'other'">
                      <label class="title-box" :for="reservation.name">
                        {{reservation.label}} <span v-if="reservation.required === 1" style="color: #c4183c">*</span>
                      </label>
                      <validation-provider
                        :rules="reservation.required === 1 ? 'required' : ''"
                        :name="reservation.name"
                        v-slot="{ errors }">
                      <textarea
                        class="reservation-style"
                        :state="errors.length ? 'invalid' : null"
                        v-model="reservation.value"
                      ></textarea>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </validation-provider>
                      <p class="reservation-note" v-if="reservation.text">{{reservation.text}}</p>
                    </div>
                    <div class="form-group reservation-box" style="margin-bottom: 1.8rem;" v-if="(reservation.type === 'select') && (reservation.multiselect === 0) && reservation.section === 'other'">
                      <validation-provider
                        :rules="reservation.required === 1 ? 'required' : ''"
                        :name="reservation.name"
                        v-slot="{ errors }">
                        <div class="form-group">
                          <label class="title-box" :for="reservation.name">
                            {{reservation.label}}
                            <span v-if="reservation.required === 1" style="color: #c4183c">*</span>
                          </label>
                          <v-select
                            :ref="reservation.ref ? reservation.ref : ''"
                            class="reservation-style reservation-style-select-mid"
                            :options="reservation.possibleValues"
                            v-model="reservation.value"
                            :reduce="boss => boss.id"
                            label="id">
                            <template #search="{attributes, events}">
                              <d-input
                                class="input-for-select"
                                :state="errors.length ? 'invalid' : null"
                                :required="!reservation.value"
                                v-bind="attributes"
                                v-on="events"
                              />
                            </template>
                            <template slot="option" slot-scope="option">
                              <div class="d-center">
                                {{ option.name }}
                              </div>
                            </template>
                            <template slot="selected-option" slot-scope="option">
                              <div class="selected d-center">
                                {{ option.name }}
                              </div>
                            </template>
                          </v-select>
                        </div>
                        <p class="reservation-note" v-if="reservation.text">{{reservation.text}}</p>
                        <div class="invalid-feedback" style="display: block; margin-top: -0.8rem;">
                          {{ errors[0] }}
                        </div>
                      </validation-provider>
                    </div>
                    <div class="form-group reservation-box" v-if="reservation.type === 'checkbox' && reservation.section === 'other'">
                      <d-checkbox
                        class="reservation-style"
                        :value="'1'"
                        :unchecked-value="'0'"
                        v-model="reservation.value"
                        :class="'mb-3'"
                        toggle>
                        <span class="title-box">{{reservation.label}}</span>
                      </d-checkbox>
                      <p class="reservation-note" v-if="reservation.text">{{reservation.text}}</p>
                    </div>
                  </div>
                </div>
                <div class="popup-box-buttons">
                  <d-button
                    theme="success"
                    class="text-nowrap"
                    @click.prevent="validateForm">
                    Potwierdź
                  </d-button>
                  <d-button
                    theme="secondary"
                    class="text-nowrap ml-3"
                    @click.prevent="closeModal">
                    Anuluj
                  </d-button>
                </div>
              </validation-observer>
              <div v-if="loaded" class="pb-3 pt-3 text-center">
                Trwa ładowanie danych&hellip;
              </div>
              <d-alert
                v-if="loadError"
                show
                theme="warning">
                Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
              </d-alert>
            </d-tab>
          </d-tabs>
        </d-card>
        <div class="visit-cancel">
          <d-button
            :theme="'secondary'"
            @click.prevent="closeModal"
            class="visit-cancel-button">
            Anuluj
          </d-button>
        </div>
      </d-form>
    </d-modal-body>
  </d-modal>
</template>

<script>
import FilterSelect from '../others/FilterSelect.vue';
import FormUtils from '../../utils/FormUtils.js';
import DatePicker from 'vue2-datepicker';
import multiSelect from 'vue-multiselect'

export default {
  name: 'reservation-list-form-add',
  components: {
    FilterSelect,
    DatePicker,
    multiSelect
  },
  data() {
    return {
      data: {},
      loaded: false,
      loadError: false,
      reservations: [],
      reservationForm: [],
      selectValue: '',
      selectWork: '',
      buttonDisable: false,
      inputWork: false,
      visibleBox: false,
      important1: false,
      important2: false,
      important3: false,
      importantDate: false,
      therapy: false,
      visible: true
    }
  },
  props: {
    showModal: {
      type: [String, Boolean],
      required: true
    },
    closeModal: {
      type: Function,
      required: true
    },
  },
  computed: {
    reservationList () {
      return this.$store.getters.getReservationList.data_fields
    },
    reservationPatient () {
      return this.$store.getters.getReservationList.patient_address
    },
    allDataLoaded () {
      return this.loaded;
    },
  },
  watch: {
    selectValue (value) {
      if (value) {
        this.visibleBox = value === 2
      }
    },
    selectWork (value) {
      if (value) {
        this.inputWork = value === 5
      }
    }
  },
  mounted () {
    this.reservationListEndpoint();
  },
  methods: {
    reservationStatsGet () {
      this.$store.dispatch('patientsReservationStatsGet')
    },
    copyData () {
      if (this.reservationList && this.reservationPatient) {
        this.reservationForm = JSON.parse(JSON.stringify(this.reservationList));
        this.patients = JSON.parse(JSON.stringify(this.reservationPatient));
      }
      setInterval(() => {
        if (this.$refs.im2BDcmcmF) {
          if (this.$refs.im2BDcmcmF[0]) {
            if (this.$refs.im2BDcmcmF[0].selectedValue) {
              if (this.$refs.im2BDcmcmF[0].selectedValue[0]) {
                this.selectValue = this.$refs.im2BDcmcmF[0].selectedValue[0].id
              }
            }
          }
        }
        if (this.$refs.aGFzbG90ZXN0b3dl) {
          if (this.$refs.aGFzbG90ZXN0b3dl[0]) {
            if (this.$refs.aGFzbG90ZXN0b3dl[0].selectedValue) {
              if (this.$refs.aGFzbG90ZXN0b3dl[0].selectedValue[0]) {
                this.selectWork = this.$refs.aGFzbG90ZXN0b3dl[0].selectedValue[0].id
                if (this.selectWork === 4) {
                  this.therapy = true;
                }
                if (this.selectWork !== 4) {
                  this.therapy = false;
                }
              }
            }
          }
        }
      }, 400)
    },
    reservationListEndpoint () {
      this.$store.dispatch('reservationListGet');
      setTimeout(() => {
        this.copyData()
      }, 500)
    },
    validateForm () {
      FormUtils.validate(this.$refs['reservation-list-form-add']);
      this.importantDate = true;
      setTimeout(() => {
        if (this.$refs.bG90ZXaGFzN0b3dl) {
          if (this.$refs.bG90ZXaGFzN0b3dl[0]) {
            if (this.$refs.bG90ZXaGFzN0b3dl[0].selectedValue) {
              this.important1 = true;
              if (this.$refs.bG90ZXaGFzN0b3dl[0].selectedValue[0].id) {
                this.important1 = false;
              }
            }
          }
        }
      }, 200);
      setTimeout(() => {
        if (this.$refs.aGFzbG90ZXN0b3dl) {
          if (this.$refs.aGFzbG90ZXN0b3dl[0]) {
            if (this.$refs.aGFzbG90ZXN0b3dl[0].selectedValue) {
              this.important2 = true;
              if (this.$refs.aGFzbG90ZXN0b3dl[0].selectedValue[0].id) {
                this.important2 = false;
              }
            }
          }
        }
      }, 200);
      setTimeout(() => {
        if (this.$refs.aGFzbXN0b3dlG90Z) {
          if (this.$refs.aGFzbXN0b3dlG90Z[0]) {
            if (this.$refs.aGFzbXN0b3dlG90Z[0].singleValue) {
              this.important3 = true;
              if (this.$refs.aGFzbXN0b3dlG90Z[0].singleValue.id) {
                this.important3 = false;
              }
            }
          }
        }
      }, 200);
      setTimeout(() => {
        if (this.$refs.aGFzbXN0b3dlG90Z[0].singleValue.id && this.$refs.aGFzbG90ZXN0b3dl[0].selectedValue[0].id && this.$refs.bG90ZXaGFzN0b3dl[0].selectedValue[0].id) {
          FormUtils.validate(this.$refs['reservation-list-form-add'], this.submitForm);
        }
      }, 500)
    },
    submitForm  () {
      let imageFields = false;
      let formDataToSend = {
        data_fields: this.reservationForm,
        patient_address: this.patients ? this.patients : ''
      };
      let endpointUrl = '/patients/reservation-list/store';
      FormUtils.submit(this, {
        $http: this.$http,
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano wniosek',
        successText: 'Wybrana rezerwacja została dodana do listy rezerwowej.',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacje rezerwacji nie powiodły się. Spróbuj ponownie.',
        successAction: () => {
          this.closeModal();
          this.reservationStatsGet();
        }
      }, imageFields);
    }
  }
}
</script>

<style lang="scss">
  @import '../../assets/scss/visits-form-popup.scss';
</style>
